import { IApiResponse } from "../../models/IAPIResponse"
import { IDropdownData } from "../../models/ICommon";
import APIService from "../../helper/api-service";
import { common, freshman_configuration, student, studentEvents, user } from "../../constants/apiUrl";
import { urlBinder } from "../../helper/url-binder";
import { IRateFeedbackData, ISendMail } from "../../models/common/IUserProfile";
import { IEventDetails } from "../../models/student/studentCourceDetail";
import { IPortalRatingData } from "../../models/common/IPortalRating";
import { IDescriptionText } from "../../models/common/IDescription";
import { IUpdateUserProfile } from "../../models/common/IUpdateUserProfile";


export default new (class commonService {

  public getColleges = async (): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_COLLEGES;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getPageBlocks = async (): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_PAGEBLOCKS;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getUserTypes = async (): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_USERTYPES;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

    public getUserSubRoles = async (): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_USERSUBROLES;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getDepartments = async (collegeId?: number): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = urlBinder(common.GET_DEPARTMENTS, [collegeId]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getNotificationTypes = async (): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_NOTIFICATION_TYPES;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getUniversities = async (): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_UNIVERSITIES;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getUserPageBlocks = async (
    userType?: number,
    masterType?: string
  ): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = urlBinder(common.GET_USER_PAGEBLOCKS, [userType, masterType]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getreportFrequencies = async (
  ): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_REPORT_FREQUENCY;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getReportNamesWithDescription = async (
  ): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_REPORT_NAME_WITH_DESCRIPTION;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getTrainingCategories = async (
  ): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_TRAINING_CATEGORY;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getAllTrainingInformation = async (
  ): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_TRAINING_NAME_WITH_DESCRIPTION_AND_DATE;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getCollegeDepartments = async (collegeIds: string): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = urlBinder(common.GET_COLLEGE_DEPARTMENTS, [`${collegeIds}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getTaskRespects = async (): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_TAST_RESPECTS;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getTaskStatus = async (): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_TASK_STATUS;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getFeedbackRate = async (
    data: IRateFeedbackData
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = student.STUDENT_RATE_FEEDBACK;
      const response = await APIService.post(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public getEventDetails = async (
    date: string
  ): Promise<IApiResponse<IEventDetails>> => {
    try {
      let endPoint = urlBinder(studentEvents.GET_EVENT_DETAILS, [`${date}`])
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IEventDetails>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IEventDetails>;
      } else {
        throw error;
      }
    }
  };

  public getCollegeTypes = async (): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_COLLEGETYPES;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public createPortalRatinng = async (
    data: any
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = common.CREATE_PORTAL_RATING;
      const response = await APIService.post(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public getPortalRatinng = async (): Promise<IApiResponse<IPortalRatingData>> => {
    try {
      let endPoint = common.GET_PORTAL_RATING;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IPortalRatingData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IPortalRatingData>;
      } else {
        throw error;
      }
    }
  };

  public getDepartmentName = async (college: string): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = urlBinder(common.GET_DEPARTMENMT_NAME, [`${college}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getCollegeName = async (userType: number): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = urlBinder(common.GET_COLLEGE_NAME, [`${userType}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public createFeedback = async (
    Feedback: ISendMail
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = common.CREATE_FEEDBACK_DETAILS;
      const response = await APIService.post(endPoint, Feedback);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public getToMailId = async (emailBlockId: number): Promise<IApiResponse<string>> => {
    try {
      let endPoint = urlBinder(common.GET_TO_MAIL_ID, [`${emailBlockId}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<string>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<string>;
      } else {
        throw error;
      }
    }
  };

  public getDescriptionText = async (
    pageBlockId: number
  ): Promise<IApiResponse<IDescriptionText>> => {
    try {
      let endPoint = urlBinder(common.GET_DESCRIPTION_TEXT, [`${pageBlockId}`])
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDescriptionText>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDescriptionText>;
      } else {
        throw error;
      }
    }
  };

  public getSubSteps = async (): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_SUBSTEPS;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getAllStudentType = async (): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = common.GET_STUDENT_TYPE;
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public updateUserProfile = async (userData: IUpdateUserProfile): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = user.UPDATE_USER_PROFILE
      const response = await APIService.put(endPoint, userData);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public getAllVersion = async (studentCategoryId?: number): Promise<IApiResponse<number[]>> => {
    try {
      let endPoint = urlBinder(freshman_configuration.GET_ALL_VERSION, [`${studentCategoryId}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<number[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<number[]>;
      } else {
        throw error;
      }
    }
  };

    public getAIAgents = async (usertype?: number): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = urlBinder(common.GET_AI_AGENTS, [`${usertype}`])
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

})();